/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type UnhideAgentMcpServerRequestBody = {
  /**
   * The MCP server, as getMyConnections reports it.
   */
  mcpServerId: string;
};

/** @internal */
export type UnhideAgentMcpServerRequestBody$Outbound = {
  mcp_server_id: string;
};

/** @internal */
export const UnhideAgentMcpServerRequestBody$outboundSchema: z.ZodMiniType<
  UnhideAgentMcpServerRequestBody$Outbound,
  UnhideAgentMcpServerRequestBody
> = z.pipe(
  z.object({
    mcpServerId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      mcpServerId: "mcp_server_id",
    });
  }),
);

export function unhideAgentMcpServerRequestBodyToJSON(
  unhideAgentMcpServerRequestBody: UnhideAgentMcpServerRequestBody,
): string {
  return JSON.stringify(
    UnhideAgentMcpServerRequestBody$outboundSchema.parse(
      unhideAgentMcpServerRequestBody,
    ),
  );
}
